"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = LodgeCard;

var _react = _interopRequireDefault(require("react"));

var _config = require("@dom/config");

var _utils = require("@dom/utils");

var _Card = _interopRequireDefault(require("./Card"));

var _RatingAndPrice = _interopRequireDefault(require("./RatingAndPrice"));

function LodgeCard(props) {
  var cardData = props.cardData;
  var name = cardData.name,
      id = cardData.id,
      address = cardData.address,
      reviews = cardData.reviews,
      coverImages = cardData.coverImages,
      averageRating = cardData.averageRating,
      startingPrice = cardData.startingPrice;

  var link = _utils.makeUrl.goToLodgeDetails(name, id, address);

  return _react["default"].createElement("a", {
    href: link
  }, _react["default"].createElement(_Card["default"], {
    images: coverImages,
    imageAlt: name
  }, _react["default"].createElement("div", {
    className: "custom-card-body"
  }, _react["default"].createElement("div", {
    className: "body-title"
  }, _react["default"].createElement("h3", null, _react["default"].createElement("i", {
    className: _config.icons.card.lodge
  }), " ", name), address && _react["default"].createElement("span", null, address)), _react["default"].createElement("div", {
    className: "custom-card-footer"
  }, _react["default"].createElement(_RatingAndPrice["default"], {
    price: startingPrice,
    pricePrefix: "From",
    numRatings: averageRating,
    numReviews: reviews ? reviews.numberOfReviews : null
  })))));
}